export default __webpack_public_path__ + "static/media/4-banner.a4316451.png";